<template>
    <div class="flex space-x-2">
        <!-- Hide add usage button for locked benefits -->
        <template v-if="!benefit.isLocked">
            <Tooltip
                v-if="isInactive"
            text="This benefit is no longer active on this card"
            x-placement="left"
            y-placement="top"
        >
            <template #trigger>
                <button
                    class="btn-icon btn-white opacity-50 cursor-not-allowed !bg-white dark:bg-slate-800 !rounded"
                    disabled
                >
                    <Icon icon="plus" svgClass="text-slate-600 dark:text-slate-300" />
                </button>
            </template>
        </Tooltip>
        <Tooltip
            v-else-if="isBenefitFullyRedeemed"
            text="Benefit has been fully redeemed for this period!"
            x-placement="left"
            y-placement="top"
        >
            <template #trigger>
                <button
                    class="btn-icon btn-white opacity-50 cursor-not-allowed !bg-white dark:bg-slate-800 !rounded"
                    disabled
                >
                    <Icon icon="plus" svgClass="text-slate-600 dark:text-slate-300" />
                </button>
            </template>
        </Tooltip>
        <button v-else class="btn-icon btn-white" @click.stop="trackUsage">
                <Icon icon="plus" />
            </button>
        </template>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import Icon from '@/components/ui/icon/icon.vue';
import Tooltip from '@/components/tooltip.vue';

const props = defineProps({
    benefit: {
        type: Object,
        required: true,
    },
});

const emit = defineEmits(['add-usage']);

const isInactive = computed(() => {
    return props.benefit?.is_active === false;
});

const isBenefitFullyRedeemed = computed(() => {
    const benefitAmount = props.benefit?.benefit?.amount || 0;
    const currentUsed = props.benefit?.current_period_usage || 0;
    return benefitAmount > 0 && currentUsed >= benefitAmount;
});

const trackUsage = () => {
    emit('add-usage', props.benefit);
};
</script>
